<template>
  <!-- :action="{
        target: upyunUpload,
        headers: {
          Authorization: auth
        },
        data: getParams,
        checkSuccess: checkSuccess
      }" -->
  <div class="upload-box">
    <cube-upload
      ref="upload"
      :auto="false"
      :simultaneous-uploads="1"
      :accept="accept"
      @file-removed="delFile"
      @files-added="filesAdded"
    />
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>
<script>
import axios from 'axios'
import { upyunUpload } from '@/lib/config'
import { uploadSignature } from '@/services/index'
import store from '@/store'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    // console.log(upyunUpload)
    return {
      /* params: {
        policy: '',
        signature: ''
      }, */
      fileList: this.data.fieldvalue || null,
      upyunUpload
    }
  },
  computed: {
    auth () {
      return store.state.auth
    },
    accept () {
      return this.data.accept || '*'
      // return '*'
    }
  },
  created () {
    this.setDefault()
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    setDefault () {
      if (!this.fileList.length) return
      this.fileList = this.fileList.map(item => {
        item.uid = item.id || 'uid' + Math.random()
        item.name = item.file_name
        item.url = item.file_url
        item.description = item.name
        item.href = item.file_url
        item.title = this.$t('message["1304"]')
        return item
      })
    },
    async filesAdded (fileList) {
      let hasIgnore = false
      let msg = ''
      for (let file of fileList) {
        if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
          file.ignore = true
          hasIgnore = true
          msg = this.$t('message["1267"]')
        }
        if (this.accept.indexOf('image') !== -1 && file.type && file.type.indexOf('image') === -1) {
          // if (file.type && file.type.indexOf('image') === -1) {
          file.ignore = true
          hasIgnore = true
          msg = this.$t('message["1599"]')
        }

        !file.ignore && this.uploadSignature(file).then(res => {
          this.uploadFile(file, res)
        })
      }

      hasIgnore && this.$createToast({
        type: 'warn',
        time: 1000,
        txt: msg
      }).show()
    },
    uploadSignature (file) {
      return new Promise(async (resolve, reject) => {
        const chain = await uploadSignature()
        chain.config({
          tip: false
        })
          .params({
            'filename': [file.name] // 文件本地路径
          })
          .onSuccess(async ([data = {}]) => {
            const {
              policy,
              signature,
              domain,
              // upyunurl,
              _upt
            } = data

            let params = {}
            params.file_url = domain + _upt
            params.policy = policy
            params.signature = signature
            // vm.action = upyunurl

            return resolve(params)
          })
          .fetch()
      })
    },
    async uploadFile (file, res) {
      let vm = this
      let formData = new FormData()
      formData.append('policy', res.policy)
      formData.append('signature', res.signature)
      formData.append('file', file)
      /* const chain = await uploadFile(upyunUpload)
      chain
        .config({
          tip: false
        })
        .params(formData)
        .onSuccess(res => {
          console.log(res)
          this.$bus.$emit('getPic', res)
        })
        .fetch() */
      axios.post(upyunUpload, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(function (response) {
          // console.log(response)
          let one = {
            file_name: file.name,
            file_url: res.file_url,
            file_size: response.data.file_size,
            file_type: response.data.mimetype
          }
          /* file_size: 83916
          image-frames: 1
          image-height: 900
          image-type: "JPEG"
          image-width: 680
          message: "ok"
          mimetype: "image/jpeg"
          sign: "b5a36f245b05529117023f39a858c6fc"
          time: 1572945987
          url: "/images/dfc0e75 */
          vm.fileList.push(one)
          vm.$emit('change', vm.fileList)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    delFile (file) {
      console.log(file)
      let filepath = file.response.data.filepath
      let index = this.fileList.findIndex(item => item === filepath)
      this.fileList.splice(index, 1)
    },
    validateFile () {
      let { fieldtype = '', fieldvalue = {}, isneeded, message } = this.data

      this.data.messages.custom = ''

      if (fieldtype !== 'file' || !isneeded) {
        return true
      }
      if (fieldvalue.length) {
        return true
      } else {
        this.data.messages.custom = message || ''
        return false
      }
    },
    resetValidate () {
      this.$refs.formItem.reset()
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-box ::v-deep {
  /* .cube-upload-btn-def {
    background: url(~@/assets/images/upload-img.png) no-repeat;
  } */
  .cube-upload-btn {
    .cube-upload-btn-def {
      text-align: center;
      i {
        &:before {
          background: #ffffff;
        }
        &:after {
          width: 100%;
          height: 100%;
          background: url(~@/assets/images/upload-img.png);
          background-size: cover;
          transform: translate(-50%, -50%) rotate(0deg);
        }
      }
    }
  }
}
</style>
